import { css, styled } from "styled-components";

import { APP_WIDTH } from "styles";
import { MD_WIDTH } from "styles/theme/layout";

import blueMobilePageBackgroundImage from "../images/blue-mobile-page-background.png";
import bluePageBackgroundImage from "../images/blue-page-background.png";
import backgroundImage from "../images/page-background-top-right.png";

export const AppWrapper = styled.div`
  max-width: ${APP_WIDTH}px;
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

type AppContainerProps = {
  $variant: "white" | "blue" | "navy";
  $isAtTop: boolean;
};

export const AppContainer = styled.div<AppContainerProps>`
  width: 100%;
  margin: 0 auto;
  flex: 1;
  display: grid;

  grid:
    "nav" auto
    "content" 1fr
    "footer" auto;

  ${(props) =>
    props.$variant === "white" &&
    css`
      ${LayoutNavWrapper} {
        background: ${({ theme }) => theme.colors.white};
      }
    `}

  ${(props) =>
    props.$variant === "blue" &&
    !props.$isAtTop &&
    css`
      ${LayoutNavWrapper} {
        background: ${({ theme }) => theme.colors.vividBlue};
      }
    `}

  ${(props) =>
    props.$variant === "blue" &&
    css`
      background-color: ${({ theme }) => theme.colors.vividBlue};
      background-image: url(${bluePageBackgroundImage});
      background-size: 50%;
      background-position: top right;
      background-repeat: no-repeat;

      @media (max-width: ${MD_WIDTH}px) {
        background-image: url(${blueMobilePageBackgroundImage});
        background-size: 100% auto;
        background-position: top left;
      }
    `}

  ${(props) =>
    props.$variant === "navy" &&
    !props.$isAtTop &&
    css`
      ${LayoutNavWrapper} {
        background: ${({ theme }) => theme.colors.navy};
      }
    `}

  ${(props) =>
    props.$variant === "navy" &&
    css`
      background-color: ${({ theme }) => theme.colors.navy};
    `}
`;

export const LayoutNavWrapper = styled.div<{ $isAtTop: boolean }>`
  grid-area: nav;
  top: 0;
  z-index: 2;
  transition: background-color 0.3s;

  @media (max-width: ${MD_WIDTH}px) {
    ${({ $isAtTop }) =>
      $isAtTop === false &&
      css`
        border-bottom: 1px solid ${({ theme }) => theme.colors.sectionBorder};
      `}
  }
`;

export const PageHeader = styled.div`
  ${({ theme }) => theme.typography.headings.heading05};
  text-transform: uppercase;
`;

export const ContentContainer = styled.div<{
  $hasBackgroundImage?: boolean;
  $hasWhiteBackground?: boolean;
}>`
  grid-area: content;

  ${({ $hasBackgroundImage }) =>
    $hasBackgroundImage &&
    `
    background-size: 33%;
    background-image: url(${backgroundImage});
    background-position: top right;
    background-repeat: no-repeat;
  `};

  ${({ $hasWhiteBackground, theme }) =>
    $hasWhiteBackground &&
    css`
      background: ${theme.colors.white};
    `};
`;

export const FooterWrapper = styled.div`
  grid-area: footer;
`;
